import { graphql } from "@opensea/graphql"
import { ItemCardMediaFragment } from "@/components/items/card/ItemCardMedia/ItemCardMedia.fragment"
import { ItemCardNameFragment } from "@/components/items/card/ItemCardName"
import { QuantityBadgeFragment } from "@/components/items/card/QuantityBadge"
import { RarityBadgeFragment } from "@/components/items/card/RarityBadge"
import { ItemLinkFragment } from "@/components/items/ItemLink"
import { useBuyItemsFragment } from "@/components/items/use-buy-items.fragment"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { EnforcementBadgeFragment } from "@/components/trustandsafety/EnforcementBadge"

export const FeaturedItemSlideFragment = graphql(
  `
    fragment FeaturedItemSlide on Item {
      name
      id
      isFungible
      ...ItemCardMedia
      ...ItemCardNameFragment
      ...RarityBadgeFragment
      ...QuantityBadge
      ...ItemLink
      ...useBuyItems
      lastSale {
        ...TokenPrice
      }
      bestListing {
        pricePerItem {
          ...TokenPrice
        }
        endTime
      }
      bestOffer {
        pricePerItem {
          ...TokenPrice
        }
      }
      enforcement {
        isCompromised
      }
      ...EnforcementBadge
    }
  `,
  [
    RarityBadgeFragment,
    TokenPriceFragment,
    ItemCardMediaFragment,
    ItemCardNameFragment,
    ItemLinkFragment,
    QuantityBadgeFragment,
    useBuyItemsFragment,
    EnforcementBadgeFragment,
  ],
)
